import { DeleteTrialEmployeesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

const useDeleteTrialEmployees = () => {
  const [deleteTrialEmployees, { loading }] = useMutation(DeleteTrialEmployeesDocument, {
    extractorFn: (data) => data.trialMutations.bulkDeleteTrialTrialEmployee,
  })
  const { company: current } = useCurrentSession()

  return {
    loading,
    bulkDelete() {
      return deleteTrialEmployees({
        variables: {
          companyId: current.id,
        },
      })
    },
  }
}

export default useDeleteTrialEmployees
